// extracted by mini-css-extract-plugin
export default {"profile":"UserProfile_profile__h3QKx","user-img":"UserProfile_user-img__Dv9av"};